import { render, staticRenderFns } from "./AppFoot.vue?vue&type=template&id=2ef56149"
import script from "./AppFoot.vue?vue&type=script&lang=js"
export * from "./AppFoot.vue?vue&type=script&lang=js"
import style0 from "./AppFoot.vue?vue&type=style&index=0&id=2ef56149&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports